<template>
  <div>
    <template v-if="!getTextModel">
      <el-input-number
        v-bind="item"
        :precision="item.precision || 6"
        v-model.number="form[item.bind]"
        :controls-position="item['controls-position'] || ''"
        @change="
          (val) => {
            item.change && item.change(val, item);
          }
        "
      ></el-input-number>
    </template>
    <div v-else>
      {{ form[item.bind] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "FormItemInputNumber",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    }
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// packages/SrAdd/components/form-item-input-number.vue